import {
	ApplicationContext,
	AuthenticationContext,
	ImageStoreState,
	DomainServicesState,
	LibraryStoreState,
	NotificationHubState,
	RegionPickerState,
	SensorStoreState,
	SubscriptionsUsageStoreState,
	WhatsNewState,
	InfoWaterProState,
	SimulationMultiSelectDialogState,
	UserTeamAccessState,
	LandingPageAccessState,
} from '../types';
import { SiteConfiguration } from '../contexts/SiteConfiguration/SiteConfigContext';
import { Settings } from '../types/settings';
import { CrossTabStoreState } from '../reducers/crossTabStates.reducer';
import { NavigateStoreState } from '../reducers/navigate.reducer';
import { AnalyticFunctionsStoreState } from './analyticFunctions';
import { IncidentsStoreState } from './incidents.types';
import { LoadingType as Loading } from './loading';
import { WarnningBannerIsVisible as warningBanner } from './warnningBanner.types';
import { IdentityProviderState } from './login.types';
import { NotificationStoreState } from './notifications';
import { ScreenSettingsStoreState } from './screenSettings.types';
import { SensorGroupStoreState } from './sensorGroups';
import { UserContext } from './userContext';
import { UserEmulationState } from './userEmulation.types';
import { WorkspacesStoreState } from './workspaces.types';
import { MoveableFrameState } from './moveableFrame.types';
import { ChatbotState } from './chatbot.types';
import { CurveManagerStoreState } from '../types/curveManager.types';
import { FeaturesStoreState } from '../reducers/features.reducer';
import { CapacityStoreState } from '../reducers/capacity.reducer';
import { UserSettingsState } from '../reducers/userSettings.reducer';

export interface SharedStoreState {
	analyticFunctions: AnalyticFunctionsStoreState;
	notifications: NotificationStoreState;
	userContext: UserContext;
	loading: Loading;
	warningBanner: warningBanner;
	sensors: SensorStoreState;
	features: FeaturesStoreState;
	settings: Settings;
	drawer: string;
	stylovyzeIncidents: IncidentsStoreState;
	stylovyzeWorkspaces: WorkspacesStoreState;
	applicationContext: ApplicationContext;
	subscriptionsUsage: SubscriptionsUsageStoreState;
	sensorGroup: SensorGroupStoreState;
	authenticationContext: AuthenticationContext;
	loginContext: IdentityProviderState;
	images: ImageStoreState;
	regionPicker: RegionPickerState;
	library: LibraryStoreState;
	userEmulation: UserEmulationState;
	navigateTo: NavigateStoreState;
	crossTabs: CrossTabStoreState;
	screenSettings: ScreenSettingsStoreState;
	whatsNew: WhatsNewState;
	notificationHub: NotificationHubState;
	siteConfig: SiteConfiguration;
	moveableFrame: MoveableFrameState;
	chatbot: ChatbotState;
	curveManager: CurveManagerStoreState;
	domainServices: DomainServicesState;
	infoWaterPro: InfoWaterProState;
	simulationMultiSelectDialog: SimulationMultiSelectDialogState;
	userTeamAccess: UserTeamAccessState;
	landingPageAccess: LandingPageAccessState;
	capacity: CapacityStoreState;
	userSettings: UserSettingsState;
}
